/* ==========================================================================
   dex-master-product.js
   Prototype source → vanilla JS.
   Covers: scroll fade-in, FAQ accordion, sample question interaction.
   No external dependencies.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- FADE IN ---- */
  function initFadeIn() {
    var els = document.querySelectorAll('.dmp-fade-in');
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e, idx) {
          if (e.isIntersecting) {
            setTimeout(function () {
              e.target.classList.add('visible');
            }, idx * 30);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      // Fallback: make all visible immediately
      els.forEach(function (el) { el.classList.add('visible'); });
    }
  }

  /* ---- FAQ ACCORDION ---- */
  function initFaq() {
    var items = document.querySelectorAll('.fq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.fq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        // Close all
        items.forEach(function (i) { i.classList.remove('open'); });
        // Toggle clicked
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ---- SAMPLE QUESTION ---- */
  function initSampleQuestion() {
    var card = document.querySelector('[data-dmp-sample]');
    if (!card) return;

    var opts     = card.querySelectorAll('.s-opt');
    var explainEl = card.querySelector('.s-explain');
    var footerEl  = card.querySelector('.s-card-foot');
    var bestLetter = (card.dataset.bestLetter || '').trim().toUpperCase();
    var explainText = card.dataset.explainText || '';
    var footerNote  = card.dataset.footerNote || '';

    // Hide explain initially
    if (explainEl) explainEl.style.display = 'none';

    // Build footer content
    if (footerEl) {
      footerEl.innerHTML =
        '<span>' + esc(footerNote) + '</span>' +
        '<span id="dmp-try-again-wrap" style="display:none">' +
          '<button class="s-try-again">Try again</button>' +
        '</span>';
    }

    var tryAgainWrap = card.querySelector('#dmp-try-again-wrap');
    var tryAgainBtn  = card.querySelector('.s-try-again');

    var picked = null;

    function reveal(letter) {
      picked = letter;
      var selectedLetter = (letter || '').trim().toUpperCase();

      if (!bestLetter || !/^[A-D]$/.test(bestLetter)) {
        opts.forEach(function (opt) {
          opt.classList.remove('selected', 'is-best', 'is-wrong');
          opt.disabled = true;
        });
        if (tryAgainWrap) tryAgainWrap.style.display = '';
        return;
      }

      opts.forEach(function (opt) {
        var l = (opt.dataset.letter || '').trim().toUpperCase();
        var spotEl = opt.querySelector('.check-spot');
        opt.classList.remove('selected', 'is-best', 'is-wrong');

        if (l === selectedLetter && l === bestLetter) {
          opt.classList.add('selected', 'is-best');
          if (spotEl) spotEl.innerHTML = SVG_CHECK_16;
        } else if (l === bestLetter) {
          opt.classList.add('is-best');
          if (spotEl) spotEl.innerHTML = SVG_CHECK_16;
        } else if (l === selectedLetter) {
          opt.classList.add('selected', 'is-wrong');
          if (spotEl) spotEl.innerHTML = SVG_X_16;
        } else {
          if (spotEl) spotEl.innerHTML = '';
        }
        opt.disabled = true;
      });

      if (explainEl) {
        explainEl.style.display = '';
        if (explainText) {
          var bestOptEl = card.querySelector('.s-opt[data-letter="' + bestLetter + '"] span:not(.letter):not(.check-spot)');
          var bestOptText = bestOptEl ? bestOptEl.textContent.trim() : bestLetter;
          explainEl.innerHTML = '<strong>Why "' + esc(bestOptText) + '" is best \xb7 </strong>' + esc(explainText);
        }
      }
      if (tryAgainWrap) tryAgainWrap.style.display = '';
    }

    function reset() {
      picked = null;
      opts.forEach(function (opt) {
        opt.classList.remove('selected', 'is-best', 'is-wrong');
        opt.disabled = false;
        var spotEl = opt.querySelector('.check-spot');
        if (spotEl) spotEl.innerHTML = '';
      });
      if (explainEl) explainEl.style.display = 'none';
      if (tryAgainWrap) tryAgainWrap.style.display = 'none';
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (picked !== null) return;
        opts.forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        reveal(opt.dataset.letter);
      });
    });

    if (tryAgainBtn) {
      tryAgainBtn.addEventListener('click', reset);
    }
  }

  /* ---- DEX MASTER SAMPLE (standalone section: data-dex-sample) ---- */
  function initDexSample() {
    var card = document.querySelector('[data-dex-sample]');
    if (!card) return;

    var opts      = card.querySelectorAll('.dex-m-sample-opt');
    var explainEl = card.querySelector('[data-dex-sample-explain]');
    var retryBtn  = card.querySelector('[data-dex-sample-retry]');
    var bestLetter = (card.dataset.dexBest || '').trim().toUpperCase();

    var picked = null;

    function revealDex(letter) {
      picked = letter;

      if (!bestLetter || !/^[A-D]$/.test(bestLetter)) {
        opts.forEach(function (opt) {
          opt.classList.remove('selected', 'is-best', 'is-wrong');
          opt.disabled = true;
        });
        if (retryBtn) retryBtn.hidden = false;
        return;
      }

      opts.forEach(function (opt) {
        var l = (opt.dataset.letter || '').trim().toUpperCase();
        opt.classList.remove('selected', 'is-best', 'is-wrong');

        if (l === letter && l === bestLetter) {
          opt.classList.add('selected', 'is-best');
        } else if (l === bestLetter) {
          opt.classList.add('is-best');
        } else if (l === letter) {
          opt.classList.add('selected', 'is-wrong');
        }
        opt.disabled = true;
      });

      if (explainEl) explainEl.hidden = false;
      if (retryBtn)  retryBtn.hidden  = false;
    }

    function resetDex() {
      picked = null;
      opts.forEach(function (opt) {
        opt.classList.remove('selected', 'is-best', 'is-wrong');
        opt.disabled = false;
      });
      if (explainEl) explainEl.hidden = true;
      if (retryBtn)  retryBtn.hidden  = true;
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (picked !== null) return;
        opts.forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        revealDex((opt.dataset.letter || '').toUpperCase());
      });
    });

    if (retryBtn) {
      retryBtn.addEventListener('click', resetDex);
    }
  }

  var SVG_CHECK_16 = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7 9 18l-5-5"/></svg>';
  var SVG_X_16     = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function boot() {
    initFadeIn();
    initFaq();
    initSampleQuestion();
    initDexSample();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
